import { render, staticRenderFns } from "./industryLabels.vue?vue&type=template&id=c8b16362&"
import script from "./industryLabels.vue?vue&type=script&lang=js&"
export * from "./industryLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports